export default __webpack_public_path__ + "static/media/flash-card.981175b8.svg";